import { ENVIRONMENTS } from '../consts/env';
import { getDeploymentConfig } from '../services/config';
import { Environment } from '../types/env';

const isValidEnvironment = (env: string): env is Environment => {
  return Object.values(ENVIRONMENTS).includes(env as Environment);
};

const getEnvironmentOrDefault = (maybeEnv: string): Environment => {
  if (isValidEnvironment(maybeEnv)) {
    return maybeEnv;
  }

  console.warn(
    `Invalid environment: ${maybeEnv}. Falling back to development.`,
  );

  return ENVIRONMENTS.DEVELOPMENT;
};

/**
 * Get the environment for settings lookup from settings.json
 * Checks VITE_SETTINGS_ENV first, then falls back to MODE
 * This allows running locally with remote environment settings
 * @returns The environment to use for settings.json
 */
export const getEnv = (): Environment => {
  return getEnvironmentOrDefault(
    import.meta.env.VITE_SETTINGS_ENV || import.meta.env.MODE,
  );
};

/**
 * Check if the current environment is airgapped mode
 * @returns True if the environment is airgapped, false otherwise
 */
export const isAirgappedMode = () => {
  return getDeploymentConfig().auth_client_type === 'airgapped_email';
};
